/**
 * Permissions List Information
  "director - perm_8d622c215bf6ede6 - Add, edit and delete other directors"
  "director - perm_4d101134685433e9 - Give special permissions to other directors"
  "director - perm_9359099be4adfb4f - Edit center name and photo"
  "director - perm_8a5723b755bf24d0 - Edit center configuration"
  "director - perm_b7f5809d176141d9 - Move directors from center"
  "director - perm_45b0a8f6e2046f00 - Move teachers from center"

  "teacher - perm_b0b6c0c5cc2eac2b - Add, edit and delete plans"
  "teacher - perm_07f92c3c6e8c5a1d - Add, edit and delete classrooms"
  "teacher - perm_56904697e3d5b057 - Add, edit and delete students"
  "teacher - perm_89a832f1fbdbdfc4 - Add, edit and delete activities from catalog (only own activities)"
  "teacher - perm_e2f18992626fba5e - Add and delete collections (catalog section)"
  "teacher - perm_a982f90900b0e911 - Remove activities from plans"
  "teacher - perm_c8d09ed2b68ad49b - Add, edit and delete teachers"
  "teacher - perm_62bcb531d5524ade - Give special permissions to other teachers"
  "teacher - perm_86d278f29de88107 - Add categories, subcategories and resources (Resources section)"
  "teacher - perm_ba48fd45f32f1dcc - Delete categories, subcategories and resources (Resources section)"
  "teacher - perm_c7ccca0f898dafed - Move students from classroom (within center)"
  "teacher - perm_68f4ca7c2eb97c1b - Create, Edit, Remove Group chats (only owned)"
 */

export enum ActionPermission {
  ADD_EDIT_DELETE_DIRECTORS = 'perm_8d622c215bf6ede6', // Director
  ADD_DIRECTORS = 'perm_8d622c215bf6ede6', // Director
  DELETE_DIRECTORS = 'perm_8d622c215bf6ede6', // Director
  EDIT_DIRECTORS = 'perm_8d622c215bf6ede6', // Director
  ADD_EDIT_DELETE_EVENTS = 'perm_dbc0d27fa4e7825f',

  GIVE_SPECIAL_PERMISSIONS_TO_DIRECTORS = 'perm_4d101134685433e9', // Director

  EDIT_CENTER_NAME_AND_PHOTO = 'perm_9359099be4adfb4f', // Director
  EDIT_CENTER_NAME = 'perm_9359099be4adfb4f', // Director
  EDIT_CENTER_PHOTO = 'perm_9359099be4adfb4f', // Director

  MOVE_DIRECTORS_FROM_CENTER = 'perm_b7f5809d176141d9',
  MOVE_TEACHERS_FROM_CENTER = 'perm_45b0a8f6e2046f00',

  ADD_EDIT_DELETE_PLANS = 'perm_b0b6c0c5cc2eac2b',
  ADD_PLANS = 'perm_b0b6c0c5cc2eac2b',
  EDIT_PLANS = 'perm_b0b6c0c5cc2eac2b',
  DELETE_PLANS = 'perm_b0b6c0c5cc2eac2b',

  ADD_EDIT_DELETE_CLASSROOMS = 'perm_07f92c3c6e8c5a1d',
  ADD_CLASSROOMS = 'perm_07f92c3c6e8c5a1d',
  EDIT_CLASSROOMS = 'perm_07f92c3c6e8c5a1d',
  DELETE_CLASSROOMS = 'perm_07f92c3c6e8c5a1d',

  ADD_EDIT_DELETE_STUDENTS = 'perm_56904697e3d5b057',
  ADD_STUDENTS = 'perm_56904697e3d5b057',
  EDIT_STUDENTS = 'perm_56904697e3d5b057',
  DELETE_STUDENTS = 'perm_56904697e3d5b057',

  EDIT_CENTER_CONFIGURATION = 'perm_8a5723b755bf24d0',

  ADD_EDIT_DELETE_OWNED_ACTIVITIES_FROM_CATALOG = 'perm_89a832f1fbdbdfc4',
  ADD_ACTIVITIES_FROM_CATALOG = 'perm_89a832f1fbdbdfc4',
  EDIT_OWNED_ACTIVITIES_FROM_CATALOG = 'perm_89a832f1fbdbdfc4',
  DELETE_OWNED_ACTIVITIES_FROM_CATALOG = 'perm_89a832f1fbdbdfc4',

  ADD_DELETE_COLLECTIONS_FROM_CATALOG = 'perm_e2f18992626fba5e',
  ADD_COLLECTIONS_FROM_CATALOG = 'perm_e2f18992626fba5e',
  EDIT_COLLECTIONS_FROM_CATALOG = 'perm_e2f18992626fba5e',
  DELETE_COLLECTIONS_FROM_CATALOG = 'perm_e2f18992626fba5e',

  REMOVE_ACTIVITIES_FROM_PLANS = 'perm_a982f90900b0e911',

  ADD_EDIT_DELETE_TEACHERS = 'perm_c8d09ed2b68ad49b',
  ADD_TEACHERS = 'perm_c8d09ed2b68ad49b',
  EDIT_TEACHERS = 'perm_c8d09ed2b68ad49b',
  DELETE_TEACHERS = 'perm_c8d09ed2b68ad49b',

  GIVE_SPECIAL_PERMISSIONS_TO_TEACHERS = 'perm_62bcb531d5524ade',

  ADD_CATEGORIES_SUBCATEGORIES_AND_RESOURCES = 'perm_86d278f29de88107',
  ADD_CATEGORIES = 'perm_86d278f29de88107',
  ADD_SUBCATEGORIES = 'perm_86d278f29de88107',
  ADD_RESOURCES = 'perm_86d278f29de88107',

  DELETE_CATEGORIES_SUBCATEGORIES_AND_RESOURCES = 'perm_ba48fd45f32f1dcc',
  DELETE_CATEGORIES = 'perm_ba48fd45f32f1dcc',
  DELETE_SUBCATEGORIES = 'perm_ba48fd45f32f1dcc',
  DELETE_RESOURCES = 'perm_ba48fd45f32f1dcc',

  MOVE_STUDENTS_FROM_CLASSROOM = 'perm_c7ccca0f898dafed',

  // LOCAL VALUES
  SCHEDULE_ACTIVITIES_TO_WEEKLY_PLAN = 'perm_schedule-activities-to-weekly-plan',
  VIEW_CLASSROOMS = 'perm_schedule-activities-to-weekly-plan',
  ADD_ACTIVITIES = 'perm_schedule-activities-to-weekly-plan', // TODO: Check if Add activities & Add activities from catalog are the same
  UPDATE_ORGANIZATION_NAME = 'update-organization-name',
  DELETE_CENTERS = 'delete-centers',
  ADD_CENTERS = 'add-centers',

  CREATE_DELETE_GROUP_CHATS = 'perm_68f4ca7c2eb97c1b',
};

export enum UserType {
  DIRECTOR = 'Director',
  TEACHER = 'Teacher',
  OWNER = 'Owner',
  ADMIN = 'Admin',
}

export interface ICurrentUser {
  confirmed: boolean;
  email: string;
  id: number;
  lastname: string;
  locale: string;
  name: string;
  new_user: boolean;
  title: string;
  type: UserType;
  permissions?: IPermission[];
  [key: string]: any;
};

export interface IPermission {
  created_at: string;
  description: string;
  id: number;
  locale: string;
  name: string;
  scope: string;
  slug: string;
}

/**
 * Returns whether a user is an admin or an owner
 *
 * @param user ICurrentUser
 * @return boolean
 */
export const isAdminOrOwner = (user: ICurrentUser) => [UserType.ADMIN, UserType.OWNER].includes(user.type);

interface IDefaultPermissions {
  [UserType.DIRECTOR]: ActionPermission[],
  [UserType.TEACHER]: ActionPermission[],
  [key: string]: ActionPermission[],
}

/**
 * The Default Permissions per Role
 *
 * @var IDefaultPermissions
 */
export const DefaultPermissions: IDefaultPermissions = {
  [UserType.DIRECTOR]: [
    ActionPermission.ADD_EDIT_DELETE_STUDENTS,
    ActionPermission.ADD_EDIT_DELETE_TEACHERS,
    ActionPermission.ADD_EDIT_DELETE_CLASSROOMS,
    ActionPermission.MOVE_STUDENTS_FROM_CLASSROOM,
    ActionPermission.GIVE_SPECIAL_PERMISSIONS_TO_TEACHERS,
    ActionPermission.ADD_EDIT_DELETE_PLANS,
    ActionPermission.ADD_DELETE_COLLECTIONS_FROM_CATALOG,
    ActionPermission.ADD_EDIT_DELETE_OWNED_ACTIVITIES_FROM_CATALOG,
    ActionPermission.ADD_CATEGORIES_SUBCATEGORIES_AND_RESOURCES,
    ActionPermission.DELETE_CATEGORIES_SUBCATEGORIES_AND_RESOURCES,
    ActionPermission.REMOVE_ACTIVITIES_FROM_PLANS,
    ActionPermission.CREATE_DELETE_GROUP_CHATS,
    // new implementation
    ActionPermission.ADD_EDIT_DELETE_EVENTS,

    // Hardcoded permissions
    ActionPermission.SCHEDULE_ACTIVITIES_TO_WEEKLY_PLAN,
    ActionPermission.VIEW_CLASSROOMS,

  ],
  [UserType.TEACHER]: [
    ActionPermission.SCHEDULE_ACTIVITIES_TO_WEEKLY_PLAN,
    ActionPermission.ADD_CATEGORIES_SUBCATEGORIES_AND_RESOURCES,
  ],
}

/**
 * Returns true of a user may do determinated action
 *
 * @param user: ICurrentUser
 * @param action: ActionPermission
 *
 * @return boolean
 */
export const can = (user: ICurrentUser, action: ActionPermission): boolean => {
  const userPermissions = [
    ...user.permissions?.map(permission => permission.slug) || [], // user special permissions
    ...DefaultPermissions[user.type] || [], // default permissions
  ];
  const pass = true;
  const shouldValidate = !isAdminOrOwner(user);

  return shouldValidate ? userPermissions.includes(action) : pass;
};
